import { Link } from 'react-router-dom';
import MainLayout from 'components/layout/main';
import { citiesColumns } from 'components/table/columns';
import Plus from 'assets/icons/plus';
import Table from 'components/table';
import CityRow from './components/CityRow';
import Search from 'ui/search';
import { useCustomSearchParams } from '../users/lib/useParams';
import { useGetCitiesQuery } from '../../graphql/queries/generated/GetCities';
import CustomPagination from 'ui/pagination';
import { useSearchParams } from 'react-router-dom';

const CitiesPage = () => {
  const { params } = useCustomSearchParams();
  const [searchParams] = useSearchParams();

  const search = params.get('search');
  const pageParam = searchParams.get('page');
  const page = pageParam ? +pageParam : 1;
  const sizeParam = searchParams.get('size');
  const size = sizeParam ? +sizeParam : 25;

  const { data, loading, error } = useGetCitiesQuery({
    variables: {
      input: {
        limit: size,
        offset: (page - 1) * size,
        searchQuery: search || undefined,
      },
    },
  });

  return (
    <MainLayout
      title="Справочник городов"
      breadCrumbs={[{ path: '/positions', name: 'Справочник городов' }]}
      error={error}
    >
      <div className="flex-1 flex flex-col">
        <div className="shadow-smena rounded-lg bg-smena_white flex-grow flex flex-col">
          <div className="flex justify-between p-4 border-b border-smena_gray-30 flex-wrap gap-y-4">
            <Search />
            <Link to="create">
              <button type="button" className="btn-primary_big flex items-center gap-x-2">
                <Plus className="text-smena_white" />
                Новый город
              </button>
            </Link>
          </div>

          <div className="flex-grow overflow-auto">
            <Table data={data?.getCities.cities} loadingData={loading} columns={citiesColumns}>
              {data?.getCities.cities?.map(city => <CityRow key={city.id} city={city} />)}
            </Table>
          </div>
          {data?.getCities.count && data.getCities.count > 0 && (
            <CustomPagination currentPage={page} total={data.getCities.count} />
          )}
        </div>
      </div>
    </MainLayout>
  );
};

export default CitiesPage;
